/*
 * @Description:
 * @usage:
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-compoent-report-methods/banner-report.ts
 */
import { Ref } from 'vue';
import useGetCommonMethods from '@/composable/use-get-common-method';
import { EMiniAppPosition } from '@/constants/mini-app';
import { report } from '@/libs/report';
import { FeedReportOpt } from '@/types/feed';
import { ModelExposureMaterialInfo } from '@/types/model';
import { IS_SSR } from '@/utils/env';

type Params = {
  btnTxt: Ref<string>,
  activeFeedReportOpt: Ref<FeedReportOpt>,
  exposureMaterialInfo: Ref<ModelExposureMaterialInfo>,
  isSupportExposureMaterial: Ref<boolean>
};

export default function useBannerReport(params: Params) {
  const { btnTxt, activeFeedReportOpt, exposureMaterialInfo, isSupportExposureMaterial } = params;
  const { materialCategory, materialId } = exposureMaterialInfo.value ?? {};
  const exposureMaterialReportOpt = {
    interact_mode_id: materialCategory === 'ws_interact_template' ? materialId : '',
    mode_id: materialCategory === 'videofunny' ? materialId : '',
    magic_id: materialCategory === 'camera' ? materialId : '',
    movie_id: materialCategory === 'recommend_template' ? materialId : '',
    h5material_id: materialCategory === 'h5_activity' ? materialId : '',
  };
  const { getMiniAppReportValue } = useGetCommonMethods();
  const mapBtnText2Status: Record<string, number> = {
    我也要拍: 1,
    立即去抢: 2,
    打开看看: 3,
  };
  const status = mapBtnText2Status[btnTxt.value] ?? 0;
  const bannerReport = {
    onClickBanner() {
      if (isSupportExposureMaterial.value) {
        report('cameratoo.bar.click', {
          ...activeFeedReportOpt.value,
          type: { ...exposureMaterialReportOpt, status },
        });
      } else {
        report('open.click', {
          ...activeFeedReportOpt.value,
          type: {
            jump_miniApp: getMiniAppReportValue(EMiniAppPosition.open),
          },
        });
      }
    },
    mountedReport() {
      if (IS_SSR) return;
      if (!isSupportExposureMaterial.value) {
        report('open.exposure', {
          ...activeFeedReportOpt.value,
          type: {
            jump_miniApp: getMiniAppReportValue(EMiniAppPosition.open),
          },
        });
      } else {
        report('cameratoo.bar.exposure', {
          ...activeFeedReportOpt.value,
          type: { ...exposureMaterialReportOpt, status },
        });
      }
    },
  };
  return bannerReport;
}
